<ion-content>
  <ion-refresher slot="fixed" (ionRefresh)="refreshView($event)" class="refresher">
      <ion-refresher-content pullingIcon="arrow-dropdown" refreshingText="Aktualisieren..."></ion-refresher-content>
  </ion-refresher>

  <ng-container *ngIf="info">
    <ion-list style="display: inline;">
        <ng-container *ngFor="let podcast of info?.podcasts">
            <ion-card *ngIf="podcast?.unlocked">
              <ion-card-header>
                <ion-card-title>
                  {{podcast?.title}}
                </ion-card-title>
              </ion-card-header>
              <ion-card-content>
                <audio controls style="width: 100%" (play)="onPlay($event)" (pause)="onPause($event)" (ended)="onEnded($event)" (abort)="onAbort($event)" (playing)="onPlaying($event)">
                  <source [src]="getSource(podcast)" type="audio/mpeg">
                </audio>
              </ion-card-content>
            </ion-card>
        </ng-container>
    </ion-list>
  </ng-container>
</ion-content>


